import { MeshBasicMaterial } from 'three';

export const whiteBasicMaterial = new MeshBasicMaterial({ color: 0xffffff, toneMapped: false });
